(function () {
  'use strict';

  /* @ngdoc object
   * @name crewSignInReport
   * @description
   *
   */
  angular
    .module('crewSignInReport', [
      'ui.router'
    ]);
}());
